import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { CONTEXT_MENU_ACTION_NAMES } from 'components/move-list/components/context-menu/config/context-menu-action-names';
import { MoveList } from 'chessboard/model/move-list/types';
import { Core } from 'chessboard/core/config/types';
import { createCoreEvent } from 'chessboard/core/model/create-core-event';

/**
 * Create remove focus node limit action
 */
export function createRemoveBegin(store: Store, storeActions: StoreActions): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.RemoveBegin,
    action: CONTEXT_MENU_ACTION_NAMES.RemoveBegin,
    isVisible,
    handler,
  };

  /**
   * Determine if the action is visible
   */
  function isVisible({ node }: ContextMenu.ActionHandlerContext): boolean {
    const begin = store.nodeLimits.get().begin;

    return begin === node.ids;
  }

  /**
   * Handle the action
   */
  function handler({ game }: ContextMenu.ActionHandlerContext) {
    const nodeLimit = { begin: null };
    const event = createCoreEvent(Core.APIEvents.NodeLimitsUpdated, nodeLimit);

    game.emit(Core.APIEvents.NodeLimitsUpdated, event);
    storeActions.setNodeLimits(nodeLimit);
  }
}
